
import React, { ReactNode, useState } from 'react';
import axios from 'axios';
// @ts-ignore: allow importing CSS without a type declaration
import '../Tracking/Tracking.css';
import Renu from '../Logo/renu-logo.png';
import Swal from "sweetalert2";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

interface TempodEntry {
    EntryDate: string;
    EntryTime: string;
    Details: string;
    Remark: string;
}

interface TrackingRecord {
    CNoteNo: string;
    InvoiceNo: string;
    ExptDateDelivery: string;
    VendorAwbNo: string;
    bookdate: string;
    ConsigneeName: string;
    Status: string;
    qty: string;
    Destination_Name: string;
    Origin_Name: string;
    Mode: string;
    recvName: string;
    statusDt: string;
    delvTime: string;
    remark: ReactNode;
    tempodData: TempodEntry[];
    ImageLink: string;
}

const RemuSupplayTracking = (): JSX.Element => {
    const [searchValue, setSearchValue] = useState('');
    const [trackingData, setTrackingData] = useState<TrackingRecord[]>([]);
    const [showImage, setShowImage] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState('');

    const handleButtonClick = () => {
        setShowImage(!showImage);
    };


    const fetchData = async () => {
        try {
            if (!searchValue.trim()) {
                Swal.fire({
                    icon: "warning",
                    title: "Enter AWB Number",
                    text: "📩 Please enter AWB No to get tracking details",
                });
                return;
            }

            // 🔥 AUTO DETECT (CNote vs RefNo)
            let url = "";

            if (searchValue.length >= 10) {
                url = `https://sunraise.in/RenusupplyTracking/GetTracking?refNo=${searchValue}`;
            } else {
                url = `https://sunraise.in/RenusupplyTracking/GetTracking?CNoteNo=${searchValue}`;
            }

            const res = await axios.get(url);

            if (res.data.status === 1) {
                setTrackingData(res.data.Data);

                setSearchValue("");

                Swal.fire({
                    icon: "success",
                    title: "Tracking Found",
                    timer: 1200,
                    showConfirmButton: false,
                });

            } else {
                Swal.fire({
                    icon: "error",
                    title: "No Data Found",
                });
            }

        } catch {
            Swal.fire({
                icon: "error",
                title: "Error fetching data",
            });
        }
    };
    return (

        <>

            <header className="navbarheader-fluid">

                {/* TOP BAR */}
                <div className="top-bar">
                    Welcome to Supply Chain Solutions Provider | Email: renusupplychain@gmail.com
                    Contact No: 91-7499349078
                </div>

                {/* DESKTOP NAVBAR */}
                <div className="navbar-container d-none d-lg-flex">

                    <div className="navbar-logo">
                        <img src={Renu} alt="logo" />
                    </div>

                    <nav className="navbar-links">
                        <a href="https://renusupplychain.com/index.php">Home</a>
                        <a href="https://renusupplychain.com/about.php">About Us</a>
                        <a href="https://renusupplychain.com/services.php">Services</a>
                        <a href="#">Document</a>
                        <a href="https://renusupplychain.com/contact.php">Contact</a>
                    </nav>

                </div>

                {/* MOBILE NAVBAR */}
                <nav className="navbar bg-light fixed-top d-lg-none">
                    <div className="container-fluid">

                        {/* MENU BUTTON */}
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        {/* LOGO */}
                        <a className="navbar-brand ms-auto" href="#">
                            <img src={Renu} alt="logo" />
                        </a>

                        {/* SIDEBAR MENU */}
                        <div className="offcanvas offcanvas-start" id="offcanvasNavbar">
                            <div className="offcanvas-header">
                                <h5>Menu</h5>
                                <button className="btn-close" data-bs-dismiss="offcanvas"></button>
                            </div>

                            <div className="offcanvas-body">
                                <ul className="navbar-nav">

                                    <li><a href="https://renusupplychain.com/index.php">Home</a></li>
                                    <li><a href="https://renusupplychain.com/about.php">About Us</a></li>
                                    <li><a href="https://renusupplychain.com/services.php">Services</a></li>
                                    <li><a href="#">Document</a></li>
                                    <li><a href="https://renusupplychain.com/contact.php">Contact Us</a></li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </nav>

            </header>
            <div className="tracking-container">
                <div className="tracking-card">

                    <h2 className="title">
                        Track a Shipment <span className="truck-icon">🚚</span>
                    </h2>

                    <div className="tracking-row">

                        <div className="input-box">
                            <input
                                type="text"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                placeholder="Enter AWB Number"
                            />
                        </div>

                        <div className="btn-group">

                            <button
                                className="track-btn"
                                onClick={fetchData}
                            >
                                Track Shipment
                            </button>

                            <button
                                className="clear-btn"
                                onClick={() => setSearchValue("")}
                            >
                                Clear
                            </button>

                        </div>

                    </div>

                </div>

                {error && <p className="error">{error}</p>}

                {trackingData.length > 0 && (
                    <div className="result-section">

                        <div className="grid">

                            {/* LEFT */}
                            <div className="card">
                                <div className="card-header">Shipment Details</div>

                                <table className="shipment-table">
                                    <tbody>

                                        <tr>
                                            <td className="label">AWB No.</td>
                                            <td>{trackingData?.[0]?.CNoteNo}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Booking Date</td>
                                            <td>{trackingData?.[0]?.bookdate}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Consignee</td>
                                            <td>{trackingData?.[0]?.ConsigneeName}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Destination</td>
                                            <td>{trackingData?.[0]?.Destination_Name}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Tracking Number</td>
                                            <td>{trackingData?.[0]?.VendorAwbNo}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Delivery Status</td>
                                            <td>{trackingData?.[0]?.Status}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Delivery Date</td>
                                            <td>{trackingData?.[0]?.statusDt}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Receiver Name</td>
                                            <td>{trackingData?.[0]?.recvName}</td>
                                        </tr>

                                        <tr>
                                            <td className="label">Delivery Remark</td>
                                            <td>{trackingData?.[0]?.remark || '-'}</td>
                                        </tr>

                                        {/* POD IMAGE */}
                                        <tr>
                                            <td className="label">Pod Image</td>
                                            <td>
                                                <div className="pod-wrapper">

                                                    <button className="btn btn-success btn-sm" onClick={handleButtonClick}>
                                                        {showImage ? 'Hide Image' : 'Pod Image'}
                                                    </button>

                                                    {showImage && (
                                                        <div className="image-container mt-2">
                                                            {trackingData?.[0]?.ImageLink ? (
                                                                <>
                                                                    <img
                                                                        src={trackingData[0].ImageLink}
                                                                        alt="POD"
                                                                        className="pod-img"
                                                                        onClick={() => setShowModal(true)}
                                                                        onError={(e) => {
                                                                            (e.target as HTMLElement).style.display = "none";
                                                                        }}
                                                                    />

                                                                    {showModal && (
                                                                        <div
                                                                            className="pod-modal"
                                                                            onClick={() => setShowModal(false)}
                                                                        >
                                                                            <img
                                                                                src={trackingData[0].ImageLink}
                                                                                className="pod-modal-img"
                                                                                alt="Full POD"
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <div className="no-image-box">No Image Available</div>
                                                            )}
                                                        </div>
                                                    )}

                                                </div>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                            {/* RIGHT */}
                            <div className="card">
                                <div className="card-header">Shipping History</div>

                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Location</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {trackingData?.[0]?.tempodData?.length > 0 ? (
                                            trackingData[0].tempodData.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item.EntryDate}</td>
                                                    <td>{item.EntryTime}</td>
                                                    <td>{item.Details}</td>
                                                    <td>{item.Remark}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={4}>No Data Available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                )} <br />

                {/* FOOTER */}
                <footer className="footer-light">
                    <div className="footer-container-fluid">

                        <div className="footer-grid">

                            {/* COLUMN 1 */}
                            <div className="footer-box">
                                <h3>RENU SUPPLY CHAIN</h3>

                                <h4>Mumbai (Head Office)</h4>
                                <p>
                                    Renu Supply Chain Pvt Ltd — India's leading end-to-end supply chain management and logistics solutions provider since 2011. Domestic & International courier services.
                                </p>
                            </div>

                            {/* COLUMN 2 */}
                            <div className="footer-box">
                                <h3>RENU SUPPLY CHAIN</h3>

                                <h4>Mumbai (Office)</h4>
                                <p>

                                    66/68 Makhriya Building, Mint Road, Cross Lane, Meena Mehta Marg, Near GPO, Fort, Mumbai – 400 001
                                </p>

                                <p>📞 +91-7499349078</p>
                                {/* <p>📞 +91 8424038718</p> */}
                                {/* <p>📞 +91 8347321111</p> */}
                                <p>✉
                                    renusupplychain@gmail.com</p>
                            </div>

                            {/* COLUMN 3 */}
                            <div className="footer-box">
                                <h3>SERVICES</h3>
                                <ul className="services-list">
                                    <li>Express Courier</li>
                                    <li>E-Commerce</li>
                                    <li>General Cargo</li>
                                    <li>Nominated Shipments</li>
                                    <li>Airline Consolidation</li>
                                    <li>Door to Door Cargo</li>
                                    <li>Dangerous Goods</li>
                                    <li>Cross Border Business</li>

                                </ul>
                            </div>

                            {/* ✅ NEW COLUMN 4 */}
                            <div className="footer-box">
                                <h3>QUICK LINKS</h3>
                                <ul className="services-list">
                                    <li>Home</li>
                                    <li>About Us</li>
                                    <li>Tracking</li>
                                    <li>Contact</li>
                                    <li>Privacy Policy</li>
                                    <li>Standard Conditions of Carriage</li>
                                    <li>Payment Terms and Conditions</li>




                                </ul>
                            </div>

                        </div>

                    </div>
                </footer>
                <div className="footer-bottom">
                    <div className="footer-bottom-container">

                        <div className="footer-left">
                            © 2026  Supply Chain Solutions Provider. Ltd. All Rights Reserved.
                        </div>

                        <div className="footer-right">
                            <a href="#">Privacy & Policy</a>
                            <a href="#">Terms and Conditions</a>
                        </div>

                    </div>
                </div>

            </div>
        </>





    );
};

export default RemuSupplayTracking;